
export enum Role {
    Content = 'content',
    Studio = 'studio',
    Admin = 'admin'
}

export const RoleRuName: Record<Role, string> = {
    [Role.Content]: 'Контент-менеджер',
    [Role.Studio]: 'Студия',
    [Role.Admin]: 'Администратор',
}

export const userStorageName = 'user-data-storage'